(() => {
  'use strict';
  if (window.customSectionSlidersInstalled) return;
  window.customSectionSlidersInstalled = true;
  const instances = new WeakMap();

  function init(scope) {
    if (typeof Swiper !== 'function') return;
    scope.querySelectorAll('[data-custom-slider-config]').forEach(configNode => {
      if (instances.has(configNode)) return;
      const root = configNode.closest('.shopify-section');
      if (!root) return;
      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (error) {
        console.warn('Invalid slider configuration', error);
        return;
      }
      const slider = root.querySelector(config.selector);
      if (!slider || slider.swiper) return;
      const options = { ...config.options };
      const nextEl = config.next ? root.querySelector(config.next) : null;
      const prevEl = config.prev ? root.querySelector(config.prev) : null;
      const scrollbar = config.scrollbar ? root.querySelector(config.scrollbar) : null;
      const pagination = config.pagination ? root.querySelector(config.pagination) : null;
      if (nextEl && prevEl) options.navigation = { nextEl, prevEl };
      if (scrollbar) options.scrollbar = { el: scrollbar, draggable: true, dragSize: 'auto' };
      if (pagination) options.pagination = { el: pagination, draggable: true };
      const swiper = new Swiper(slider, options);
      const controller = new AbortController();
      root.querySelectorAll('.reviewcards').forEach(card => {
        const text = card.querySelector('.testimonial_text');
        const button = card.querySelector('.read-toggle');
        if (!text || !button) return;
        button.style.display = text.scrollHeight > text.clientHeight ? 'inline-block' : 'none';
        button.addEventListener('click', () => {
          const expanded = card.classList.toggle('expanded');
          button.textContent = expanded ? 'Read Less' : 'Read More';
          button.setAttribute('aria-expanded', String(expanded));
        }, { signal: controller.signal });
      });
      instances.set(configNode, { swiper, controller });
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-custom-slider-config]').forEach(node => {
      const state = instances.get(node);
      if (!state) return;
      state.swiper.destroy(true, true);
      state.controller.abort();
      instances.delete(node);
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
